// extracted by mini-css-extract-plugin
module.exports = {"desktop-only":"instructor-header_desktop-only__X7rL3","mobile-only":"instructor-header_mobile-only__BBDft"};